import React from 'react';

const Error = () => {
    return (
        <div>
            <h4 style={{color:"white"}}>없는 주소를 입력하였습니다.</h4>
        </div>
    );
};

export default Error;